import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user.model';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-departments-tabs-user',
  templateUrl: './departments-tabs-user.component.html',
  styleUrls: ['./departments-tabs-user.component.css']
})
export class DepartmentsTabsUserComponent implements OnInit {

  flag = true;
  user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  isStorekeeper = false;

  constructor(
    public userService: UserService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.checkRole();
    this.applyRequestedTab();
  }

  change(data) {
    this.flag = data;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.role === 'ROLE_ADMIN') {
      this.isAdmin = true;
    } else if (this.user.role === 'ROLE_HEAD') {
      this.isHead = true;
    } else if (this.user.role === 'ROLE_USER') {
      this.isUser = true;
    }
    this.isStorekeeper = this.hasStorekeeperRole();
  }

  hasStorekeeperRole(): boolean {
    if (!this.user || !this.user.roles) {
      return false;
    }
    if (this.user.roles.indexOf('ROLE_STOREKEEPER') !== -1) {
      return true;
    }
    return this.user.roles.indexOf('STOREKEEPER') !== -1;
  }

  private applyRequestedTab(): void {
    if (!this.isStorekeeper) {
      return;
    }
    if (this.route.snapshot.queryParams['tab'] === 'employees' || this.isMobileView()) {
      this.flag = false;
    }
  }

  private isMobileView(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 1023;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/departments-tabs-user/departments-tabs-user.component.ts